import styled, { css, FlattenSimpleInterpolation } from "styled-components";

import theme from "../../../../theme";
import { DotType } from "../VerticalProgressBar.component";

export interface IDotProps {
  dotType: DotType;
  horizontalPadding?: number;
}

const Dot = styled.div`
  position: relative;
  margin: 4px 8px;
  border-radius: 50%;
  background-color: ${theme.colors.brown};

  ${({ dotType }: IDotProps): string | FlattenSimpleInterpolation =>
    dotType === "check"
      ? css`
          width: 20px;
          height: 20px;

          &:after {
            position: absolute;
            content: "";
            display: none;
            width: 9px;
            height: 4px;
            top: 6px;
            left: 5px;
            border-left: 1px solid white;
            border-bottom: 1px solid white;
            transform: rotate(-45deg);
          }
        `
      : css`
          width: 10px;
          height: 10px;
        `};
`;

export default Dot;
